/** Recognise document bytes, not an HTTP-success HTML page or LFS pointer. */
export function isPDFHeader(bytes) {
  return new TextDecoder().decode(bytes.slice(0, 5)) === '%PDF-';
}

export async function verifiedDocumentUrl(url, request = fetch) {
  if (!url) return null;
  if (!/\.pdf(?:\?|$)/i.test(String(url))) return url;
  let reader;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await request(url, { headers: { Range: 'bytes=0-1023' }, signal: controller.signal });
    if (!response.ok || !response.body) return null;
    reader = response.body.getReader();
    const header = new Uint8Array(5);
    let length = 0;
    while (length < 5) {
      const chunk = await reader.read();
      if (!chunk.value?.length) return null;
      const part = chunk.value.slice(0, 5 - length);
      header.set(part, length); length += part.length;
    }
    return isPDFHeader(header) ? url : null;
  } catch { return null; }
  finally { clearTimeout(timer); if (reader) await reader.cancel().catch(() => {}); }
}